import { render, staticRenderFns } from "./projectForm.vue?vue&type=template&id=39e27104&"
import script from "./projectForm.vue?vue&type=script&lang=ts&"
export * from "./projectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports